import { render, staticRenderFns } from "./MonitorEnvioRecurso.vue?vue&type=template&id=5a1918d0"
import script from "./MonitorEnvioRecurso.vue?vue&type=script&lang=js"
export * from "./MonitorEnvioRecurso.vue?vue&type=script&lang=js"
import style0 from "./MonitorEnvioRecurso.vue?vue&type=style&index=0&id=5a1918d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports